module.exports = __webpack_public_path__ + "fdd03219.png";